"use client";

import { ChampionIcon } from "@/shared/ui/data-display/champion-icon";
import { cn } from "@/shared/lib/utils";

import type { ChampionPoolSide } from "../model/use-match-champion-pools";

/**
 * Одна сторона пула: подпись и сетка иконок чемпионов.
 *
 * Обычная игра — 3×2 на мобильном и 6×1 на десктопе; гранд-финал (10 чемпионов) —
 * 5×2 на любом размере, чтобы блок не растягивался в одну длинную строку.
 * Ролей не подписываем: пул безликий по правилам режима.
 */
export function ChampionPoolGrid({
  side,
  label,
  championNames,
}: {
  side: ChampionPoolSide;
  label: string;
  /** id → локализованное имя; используется в title/alt и для читаемости. */
  championNames?: Map<string, string>;
}) {
  const isFinal = side.championIds.length > 6;

  return (
    <div className="min-w-0 space-y-2">
      <div className="text-[11px] uppercase tracking-wide text-muted-foreground">
        {label}
      </div>
      <div
        className={cn(
          "grid gap-1.5",
          isFinal ? "grid-cols-5" : "grid-cols-3 sm:grid-cols-6",
        )}
      >
        {side.championIds.map((championId) => (
          <ChampionIcon
            key={championId}
            name={championId}
            label={championNames?.get(championId) ?? championId}
            title={championNames?.get(championId) ?? championId}
            size={48}
            className="rounded-md"
          />
        ))}
      </div>
    </div>
  );
}
